document.addEventListener("DOMContentLoaded", function() {
    const verses = {
        0: { text: "So let's not get tired of doing what is good. At just the right time we will reap a harvest of blessings if we don't give up", reference: "Galatians 6:9" },
        1: { text: "Take delight in the Lord, and He will give you your heart's desires. Commit everything you do to the Lord. Trust Him, and He will help you.", reference: "Psalm 37:4-5" },
        2: { text: "And it is impossible to please God without faith. Anyone who wants to come to Him must believe that God exists and that He rewards those who sincerely seek Him.", reference: "Hebrews 11:6" },
        3: { text: "Be kind and compassionate to one another, forgiving each other, just as in Christ God forgave you.", reference: "Ephesians 4:32" },  
        4: { text: "Don't worry about anything; instead, pray about everything. Tell God what you need, and thank Him for all He has done. Then you will experience God's peace, which exceeds anything we can understand. His peace will guard your hearts and minds as you live in Christ Jesus.", reference: "Philippians 4:6-7" },
        5: { text: "Trust in the LORD with all your heart, do not depend on your own understanding. Seek His will in all you do, and He will show you which path to take.", reference: "Proverbs 3:5-6" },
        6: { text: "May the God of hope fill you with all joy and peace as you trust in Him, so that you may overflow with hope by the power of the Holy Spirit.", reference: "Romans 15:13" }
        // Add the rest of the week's verses here following the same format
        // ...
    };

    const today = new Date();
    const dayOfWeek = today.getDay();
    const formattedDate = today.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }); // Formats the date as "Month Day"

    console.log("Today is day:", dayOfWeek);
    console.log("Formatted date:", formattedDate);
  
    // Update the verse of the day
    if(verses[dayOfWeek]) {
    console.log("Verse for today:", verses[dayOfWeek]);
        document.getElementById("verse-date").innerText = formattedDate;
        document.getElementById("daily-verse").innerText = verses[dayOfWeek].text;
        document.getElementById("verse-reference").innerText = `- ${verses[dayOfWeek].reference}`;
    }

  else {
        console.log("No verse found for today.");
    }
  
});
